import { createSlice } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '@/constants';

export interface IUserAvatarState {
    /** Токен cache-bust аватара текущего пользователя; растёт при смене своего фото. */
    version: number;
}

const initialState: IUserAvatarState = {
    version: 0,
};

export const UserAvatarSlice = createSlice({
    name: SLICE_NAMES.USER_AVATAR,
    initialState,
    reducers: {
        // Сменили своё фото → меняем версию, чтобы <img> перезапросил аватар по новому URL.
        bumpAvatarVersion: (state) => {
            state.version += 1;
        },
        // Сброс при логауте/смене пользователя (имя сохранено — его зовёт auth-флоу).
        clearAvatar: (state) => {
            state.version = 0;
        },
    },
});

export const { bumpAvatarVersion, clearAvatar } = UserAvatarSlice.actions;

export default UserAvatarSlice.reducer;
